import { App } from 'vue';

import { SYMBOL_STYLE } from '@constants/symbol-style';

const SymbolStylePlugin = {
  install(app: App) {
    app.provide('$symbolStyle', SYMBOL_STYLE);
  },
};

export default SymbolStylePlugin;
